/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import BufferCalculationOption from './bufferCalculationOption';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { removeDefaultStyles } from '../../../Utils/buttonStyle';
import styles from './bufferCalculation.module.scss';
import AddIcon from '@mui/icons-material/Add';

const BufferCalculationItem = ({
  item,
  openAccordionId,
  toggleAccordion,
  addEfforts,
  handleFieldChange,
  handleIncrement,
  handleDecrement,
  saveEffort,
  deleteEffort,
  editEfforts,
  timeUnits,
  hasAccess,
}) => (
  <div key={item.id} className={styles['bufferCalculation-item']}>
    <div className={styles['bufferCalculation-header']}>
      <button
        style={removeDefaultStyles}
        onClick={() => toggleAccordion(item.id)}
      >
        <div className={styles['bufferCalculation-toggle']}>
          {openAccordionId.includes(item.id) ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          )}
        </div>
      </button>
      <div className={styles['bufferCalculation-title']}>{item.title}</div>
      <button style={removeDefaultStyles} onClick={() => addEfforts(item.id)}
        disabled={!hasAccess('create') || (Array.isArray(item.options) ? item.options.length : 0) >= 4}
        className={styles['bufferCalculation-add-btn']}
      >
        <div className={styles['bufferCalculation-add']}>
          <AddIcon sx={{ fontSize: 18 }} />
          <div className={styles['bufferCalculation-addText']}>Add</div>
        </div>
      </button>
    </div>
    {openAccordionId.includes(item.id) && (
      <div className={styles['bufferCalculation-options-main']}>
        {item.options?.map((option) => (
          <BufferCalculationOption
            key={option.id}
            item={item}
            option={option}
            handleFieldChange={handleFieldChange}
            handleIncrement={handleIncrement}
            handleDecrement={handleDecrement}
            saveEffort={saveEffort}
            deleteEffort={deleteEffort}
            editEfforts={editEfforts}
            timeUnits={timeUnits}
            hasAccess={hasAccess}
          />
        ))}
      </div>
    )}
  </div>
);

BufferCalculationItem.propTypes = {
  item: PropTypes.object.isRequired,
  openAccordionId: PropTypes.array.isRequired,
  toggleAccordion: PropTypes.func.isRequired,
  addEfforts: PropTypes.func.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  handleIncrement: PropTypes.func.isRequired,
  handleDecrement: PropTypes.func.isRequired,
  saveEffort: PropTypes.func.isRequired,
  deleteEffort: PropTypes.func.isRequired,
  editEfforts: PropTypes.func.isRequired,
  timeUnits: PropTypes.array.isRequired,
  hasAccess: PropTypes.func.isRequired,
};

export default BufferCalculationItem;
